import StoreDetailsContainer from "./StoreDetailsContainer";

export default StoreDetailsContainer;
